import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { SchemaTreeComponent } from '../schema-tree/schema-tree.component';
import { SchemaTreeHandler } from '../../clases/SchemaTreeHandler';
import { BeNeo4jService } from '../../services/be-neo4j.service';
import { SharedService } from '../../services/shared.service';
import { Overview } from '../../abstract/Overview';
import { CommonModule } from '@angular/common';
import { SchemaTree } from '../../clases/SchemaTree';
import { CLOSE, SELECT_DATA_SERVICE_FIRST, TAXONOMY_EXPLORER } from '../../shared/strings';
import { MainComponent } from '../../pages/main/main.component';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ServerResponse } from '../../interfaces/ServerResponse';
import { ISchemaTree } from '../../interfaces/SchemaTree';
import { createSchemaTreeRecursive } from '../../utils/utils';
import { TaskNotificationService } from '../../services/task-notification.service';

@Component({
  selector: 'taxonomy-overview',
  standalone: true,
  imports: [
    CommonModule,
    SchemaTreeComponent,
    MatButtonModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './taxonomy-overview.component.html',
  styleUrl: './taxonomy-overview.component.scss'
})
export class TaxonomyOverviewComponent extends Overview implements OnInit, AfterViewInit{

  TAXONOMY_EXPLORER = TAXONOMY_EXPLORER;
  SELECT_DATA_SERVICE_FIRST = SELECT_DATA_SERVICE_FIRST;
  CLOSE = CLOSE;

  handler!: SchemaTreeHandler;

  schemaTree!: SchemaTree[];
  isLoadingTaxonomy = false;

  @Input() mainComponent!: MainComponent;
  @ViewChild(SchemaTreeComponent) treeComponent!: SchemaTreeComponent;

  constructor(
    private beNeo4jService: BeNeo4jService,
    private sharedService: SharedService,
    private taskNotificationService: TaskNotificationService
  ){
    super();
  }

  ngOnInit(): void {
    this.isOverviewActive = false;
  }

  ngAfterViewInit(): void {
    this.handler = new SchemaTreeHandler(this.beNeo4jService, (result: any)=>{
      let dataView = this.mainComponent.getCurrentDataView();
      if(dataView)dataView.executeFromMenu(result.result);
    }, this.refreshTaxonomyData, this.taskNotificationService);
  }

  setSchemaTree(schemaTree: SchemaTree[]){
    this.schemaTree = schemaTree;
    if(this.treeComponent) this.treeComponent.setSchemaTree(schemaTree);
  }

  refreshTaxonomyData = ()=>{
    this.isLoadingTaxonomy = true;
    this.beNeo4jService.schemaTree().subscribe({
      next: (schemaTree: ServerResponse<ISchemaTree>)=>{
        console.log(schemaTree);
        let tree = (schemaTree as any).result.map((schema: ISchemaTree) => createSchemaTreeRecursive(schema));
        this.sharedService.data_service_data.schemaTree = tree;
        this.setSchemaTree(tree);
        this.isLoadingTaxonomy = false;
      },
      error: () => {
        this.isLoadingTaxonomy = false;
      }
    });
  }

}
